import { CRUDAction, FeatureKey } from 'common/constants/permission'
import useMedia from 'common/hooks/useMedia'
import { usePermitToActionFeature } from 'modules/user/api/selector'
import { useTranslation } from 'react-i18next'

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'

import { RecordFeatureButton } from 'components/RecordFeatureButton'

import MedicalSupplyDialog from '../MedicalSupplyDialog'
import MedicalSupplyOverview from '../MedicalSupplyOverview'
import MedicalSupplyTable from '../MedicalSupplyTable'

const MedicalSupply = () => {
  const showRecordBtn = usePermitToActionFeature([CRUDAction.Create], FeatureKey.Medicine)
  const isMobile = useMedia('sm')
  const { t } = useTranslation('medicalsupply')

  return (
    <Box sx={{ py: isMobile ? 0 : 3 }}>
      <RecordFeatureButton
        buttonText={t('record.medicine')}
        dialog={({ open, onClose }) => <MedicalSupplyDialog open={open} onClose={onClose} />}
        showButton={showRecordBtn}
      />
      <Grid container spacing={2} sx={{ height: 'max-content' }}>
        <Grid item xs={12}>
          <MedicalSupplyOverview />
        </Grid>
        <Grid item xs={12}>
          <MedicalSupplyTable />
        </Grid>
      </Grid>
    </Box>
  )
}

export default MedicalSupply
